import * as React from 'react';
import { Alert, Badge } from 'reactstrap';
import { AlertMessage, AlertsProps } from '../../clientState/alerts/types';
import withAlerts from './withAlerts';

const DismissableAlert = ({
    alert,
    removeAlert
}: {
    alert: AlertMessage;
    removeAlert: () => void;
}) => (
    <Alert
        className="my-3"
        color={alert.color}
        toggle={removeAlert}
        transition={{ in: true, timeout: 0 }}
    >
        {alert.message}{' '}
        {alert.count && alert.count > 1 ? (
            <Badge color={alert.color} className="ml-2">
                {alert.count}
            </Badge>
        ) : null}
    </Alert>
);

const Alerts = ({ alerts, removeAlert }: AlertsProps) => (
    <div className="alerts-container">
        {alerts && alerts.length
            ? alerts.map(a => (
                  <DismissableAlert
                      key={a.id}
                      alert={a}
                      // tslint:disable-next-line:jsx-no-lambda
                      removeAlert={() => removeAlert({ message: a.message })}
                  />
              ))
            : null}
    </div>
);

export default withAlerts(Alerts);



// WEBPACK FOOTER //
// ./src/client/components/Alerts/index.tsx